<template>
  <el-row type="flex" class="row-bg" justify="space-around">
    <el-col :span="9"></el-col>
    <el-col :span="6">
      <div class="middle-box">
        <h1>404</h1>
        <h3 class="font-bold">{{ $t('w482') }}</h3>
        <div class="error-desc">
          {{ $t('w483') }}
        </div>
        <!-- <div class="m-t">
          <a href="/" class="btn btn-danger">{{ $t('w484') }}</a>
        </div> -->
      </div>
    </el-col>
    <el-col :span="9"></el-col>
  </el-row>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .middle-box {
    max-width: 400px;
    z-index: 100;
    margin: 0 auto;
    padding-top: 40px;
    text-align: center;
    color: #333;
  }
  .middle-box h1 {
    font-weight: 100;
    font-size: 170px;
  }
  .btn {
    display: inline-block;
    padding: 6px 12px;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 3px;
  }
  .btn-danger {
    background-color: #ed5565;
    border-color: #ed5565;
    color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/404.vue